module.exports = __webpack_public_path__ + "static/media/ShopOnBudget2.9e9bb02a.png";